import React from 'react';
import { withResponsiveFlags, useResponsiveTextProps } from "~/hoc/withResponsiveProps";
import { H1, H3, HStack, Icon } from "~/native-ui"
import Tooltip from '../Tooltip/Tooltip';

const verticalAlignStyle = {verticalAlign: 'middle'};
const ResponsiveTitle = withResponsiveFlags(({ title, icon, iconFamily, tooltip, modelId, isSmallScreen, ...rest }) => {
    const textProps = useResponsiveTextProps(isSmallScreen, isSmallScreen ? 150 : 0, 218);

    const TitleComponent = isSmallScreen ? H3 : H1;

    const titleBody = (
        <TitleComponent { ...rest } style={React.useMemo(() => ([rest.style, verticalAlignStyle]), [rest.style])}>
            {title}
            {tooltip && tooltip.length && <Tooltip leftMargin tooltip={tooltip} modelId={modelId} />}
        </TitleComponent>
    )

    if (!icon) return titleBody;

    return (
        <HStack {...textProps} alignItems="center" space="2">
            <Icon color="muted.700" size={isSmallScreen ? "4" : "6"} type={icon} iconFamily={iconFamily}></Icon>
            {titleBody}
        </HStack>
    )
}, { includeKeys: ['isSmallScreen'] });

export default ResponsiveTitle;